module.exports = __webpack_public_path__ + "Server-Unknown.Ssh.3ac24f4a3e76e842c904e68171b1d9e1.hashedasset.svg";